import axios from 'axios';
import * as endpoint from '../../../endpoint';
import {
  checkCancelToken,
  consolelog,
  delCancelToken,
} from '../../../../lib/tools';
import {
  createCancelToken,
  handleErrorResponse,
  i18nMessages,
} from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';
import { REPORT_UPDATE_ERROR_CODE } from '../../../../lib/constants';

/**
 * 報告書のフレームを作成する。
 *
 * @param {string} apiToken - APIトークン
 * @param {string} groupId - グループID。このグループに紐づく報告書フレームを作成する。
 * @param {string} reportId - 報告書ID。この報告書に紐づく報告書フレームを作成する。
 * @param {object} apiParams - リクエスト項目。
 * @returns {Function} dispatch - Redux dispatch関数
 */
const createReportFrames =
  (apiToken, groupId, reportId, apiParams) => async dispatch => {
    consolelog('[API CALL] createReportFrames()', apiToken);
    configureAxiosForJSON(apiToken);

    // キャンセルトークンの設定
    const { cancelToken, cancelTokenKey } =
      createCancelToken('createReportFrames');

    // urlの設定
    const url = endpoint.API_REPORT_FRAMES.replace(
      '{groupId}',
      groupId,
    ).replace('{reportId}', reportId);

    // axiosの設定オプション
    const axiosConfig = {
      cancelToken,
    };

    try {
      const res = await axios.post(url, apiParams, axiosConfig);
      if (checkCancelToken(cancelTokenKey) && res.status === 200) {
        return res;
      }
      return null;
    } catch (thrown) {
      // 既に完了ステータスの場合はデフォルトのエラーハンドリングをスキップする
      if (
        thrown?.response?.status !== 400 &&
        thrown?.response?.data?.errorCode !==
          REPORT_UPDATE_ERROR_CODE.UNEDITABLE_CONTENT
      ) {
        handleErrorResponse(
          thrown,
          dispatch,
          '',
          i18nMessages['userPrompt.message.reportCreationFailed'],
        );
      }
      return thrown;
    } finally {
      delCancelToken(cancelTokenKey);
    }
  };

export default createReportFrames;
